<!--
 * @Descripttion: 
 * @Author: congz
 * @Date: 2020-08-09 12:53:22
 * @LastEditors: congz
 * @LastEditTime: 2020-08-09 21:31:44
-->
<template>
  <div class="user-pass" id="user-pass" name="user-pass">
    <div class="user-pass-layout">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="user-pass-content">
            <div class="extra"></div>
            <div class="user-pass-title">
              <p>Change password
              </p>
            </div>
            <div class="user-pass-form">
              <el-form :model="form" status-icon :rules="rules" ref="form" label-width="150px">
                <el-form-item label="New Password" prop="new_password">
                  <el-input type="password" v-model="form.new_password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password" prop="password_confirm">
                  <el-input type="password" v-model="form.password_confirm" autocomplete="off"></el-input>
                </el-form-item>
                <p
                  style="margin-left:20px;margin-bottom:10px;color:#757575;font-size:15px"
                >{{message}}</p>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="submitForm('form')"
                  >Submit</el-button>
                  <el-button @click="resetForm('form')">Reset</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="extra"></div>
            <div class="extra"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as userAPI from '@/api/users'
export default {
  name: 'UpdatePass',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      } else {
        if (this.form.password_confirm !== '') {
          this.$refs.form.validateField('password_confirm')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.form.new_password) {
        callback(new Error('The password entered twice is inconsistent!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        new_password: '',
        password_confirm: ''
      },
      rules: {
        new_password: [{ validator: validatePass, trigger: 'blur' }],
        password_confirm: [{ validator: validatePass2, trigger: 'blur' }]
      },
      message: 'Please enter your new password (no old password required)'
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          userAPI
            .changePassword({ old_password: '', new_password: this.form.new_password })
            .then(res => {
              if (res.status === 200) {
                this.notifySucceed('Password changed successfully')
                this.message = 'Password changed successfully'
                this.$refs[formName].resetFields()
              } else {
                this.notifyError('Failed to change password', res.msg)
              }
            })
            .catch(error => {
              this.notifyError('Failed to change password', error)
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.user-pass-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.user-pass-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.user-pass-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.user-pass-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.extra {
  height: 10px;
}
.user-pass-form {
  width: 500px;
}
.bind-email {
  margin-left: 50px;
  color: #757575;
}
.bind-email .bind-email-href {
  color: #757575;
  margin-left: 5px;
  margin-right: 5px;
}
.bind-email .bind-email-href:hover {
  color: #5B21B6;
}
</style>